// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.containerVisuAlunos{
    height: 100%;
    margin-left: 1.4em;
    margin-right: 1.9em;
}

.topoInfo{
  display: flex;
  margin-top: 1.5em;
  justify-content: space-between;
  align-items: center;
}

.btnVoltarAlunos{
    border: none;
    background-color:var(--cor-branco);
    font-size: 1.5em;
    font-weight: 400;
    font-family: "Roboto";
    cursor: pointer;
}

.iconVisuAlunos{
  width: 10px;
  margin-right: 10px;
}

.btnEditar {
    width: 15%;
    height: 40px;
    color: var(--cor-roxoEscuro);
    font-family: "Roboto";
    display: flex;
    font-size: 100%;
    font-weight: 500;
    align-items: center;
    justify-content: center;
    background-color: var(--cor-roxoPastel);
    border: 1px solid var(--cor-roxoEscuro);
    border-radius: 8px;
    cursor: pointer;
}

.btnEditar:hover {
  box-shadow: 1px 1px 3px var(--cor-roxoEscuro);
}

.containerInformacoesAlunos{
  margin-top: 30px;
  margin-bottom: 30px;
  width: 98.8%;
  height: 13vh;
  margin-right: 10px;
  border-radius: 12px;
  background-color: var(--cor-roxoClaro);
  border: none;
  outline: none;
  padding-left: 25px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.paragrafoNome,
.paragrafoTelefone,
.paragrafoTurma{
  margin-top: 20px;
  display: flex;
  flex-direction: column;
}

.nome,
.telefone,
.turma{
  font-weight: 500;
}

.tabelaLivros span{
  display: flex;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/paginas/funcionario/VisualizacaoAlunos.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;IACI,YAAY;IACZ,kCAAkC;IAClC,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,4BAA4B;IAC5B,qBAAqB;IACrB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,uCAAuC;IACvC,uCAAuC;IACvC,kBAAkB;IAClB,eAAe;AACnB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;EACtC,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;;;EAGE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB","sourcesContent":[".containerVisuAlunos{\n    height: 100%;\n    margin-left: 1.4em;\n    margin-right: 1.9em;\n}\n\n.topoInfo{\n  display: flex;\n  margin-top: 1.5em;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.btnVoltarAlunos{\n    border: none;\n    background-color:var(--cor-branco);\n    font-size: 1.5em;\n    font-weight: 400;\n    font-family: \"Roboto\";\n    cursor: pointer;\n}\n\n.iconVisuAlunos{\n  width: 10px;\n  margin-right: 10px;\n}\n\n.btnEditar {\n    width: 15%;\n    height: 40px;\n    color: var(--cor-roxoEscuro);\n    font-family: \"Roboto\";\n    display: flex;\n    font-size: 100%;\n    font-weight: 500;\n    align-items: center;\n    justify-content: center;\n    background-color: var(--cor-roxoPastel);\n    border: 1px solid var(--cor-roxoEscuro);\n    border-radius: 8px;\n    cursor: pointer;\n}\n\n.btnEditar:hover {\n  box-shadow: 1px 1px 3px var(--cor-roxoEscuro);\n}\n\n.containerInformacoesAlunos{\n  margin-top: 30px;\n  margin-bottom: 30px;\n  width: 98.8%;\n  height: 13vh;\n  margin-right: 10px;\n  border-radius: 12px;\n  background-color: var(--cor-roxoClaro);\n  border: none;\n  outline: none;\n  padding-left: 25px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n}\n\n.paragrafoNome,\n.paragrafoTelefone,\n.paragrafoTurma{\n  margin-top: 20px;\n  display: flex;\n  flex-direction: column;\n}\n\n.nome,\n.telefone,\n.turma{\n  font-weight: 500;\n}\n\n.tabelaLivros span{\n  display: flex;\n  justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
